import OrganizationsComponent from '../../components/Organizations/Organizations';

function Organizations() {
  return <OrganizationsComponent />;
}

export default Organizations;
